import { useTranslation } from 'react-i18next'

import { FieldStackedLabel } from '../../../../../Field'
import { FormFieldSelectNG } from '../../../../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../../../Formik'
import { ButtonSelect } from '../../../../../Select'
import { getVisibilityForDwellersOptions } from '../../ConnectedRequestsMassEditModalFields.utils'

import * as styles from '../../../ConnectedRequestsMassEditModal.module.css'

function VisibilityValueField({ label, name, placeholder }) {
  const { t } = useTranslation()

  const visibilityForDwellersOptions = getVisibilityForDwellersOptions(t)

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Field={FieldStackedLabel}
      Select={ButtonSelect}
      controlProps={{
        contentProps: {
          placeholderProps: {
            text: placeholder,
          },
        },
      }}
      fieldComponentProps={{
        className: styles.valueFieldStackedLabel,
        label,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={name}
      options={visibilityForDwellersOptions}
    />
  )
}

export default VisibilityValueField
